import React from "react";
import AppHeader from "../components/layout/appHeader";

const withAppBar = (WrappedComponent) => {
  const decodedUserinfo =localStorage.getItem("UserInfo");
  return (props) => {
    return (
      <div>
        <AppHeader></AppHeader>
        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default withAppBar;
